module.exports = __webpack_public_path__ + "static/media/07_andinvainthedreamer.2c188f8d.jpg";